import React from 'react'
// libs
import { change } from 'redux-form'
import { useDispatch } from 'react-redux'
// components
import { ReduxInput } from 'components/FormElements'
import ReduxLocationPicker from 'components/FormElements/ReduxForm/ReduxLocationPicker'
// constants
import { Forms } from 'constants/forms'
// types
import { Place } from 'components/FormElements/LocationPicker'

const LocationSection: React.FC = () => {
  const dispatch = useDispatch()

  const onLocationChange = (address: { value: Place }) => {
    dispatch(change(Forms.BUSINESS_ACTIVITY_FORM, 'lat', address?.value.latitude))
    dispatch(change(Forms.BUSINESS_ACTIVITY_FORM, 'long', address?.value.longitude))
  }
  return (
    <>
      <ReduxLocationPicker name='address' label='Location Address' onChange={onLocationChange} />
      <ReduxInput name='lat' label='Location Latitud' disabled />
      <ReduxInput name='long' label='Location Longitude' disabled />
    </>
  )
}

export default LocationSection
